import { AxiosRequestConfig } from 'axios';
import { ActionContext } from 'vuex';

import { fetchActiveCrops } from '@/shared/api/rest/RestApi';
import { ApiResponse, Product } from '@/shared/api/rest/models';
import subscribableData from '@/shared/mixins/store/subscribableData/index';
import { SubscribableDataState } from '@/shared/mixins/store/types';
import { RootState } from '@/store/types';

export async function fetchAll(
  context: ActionContext<SubscribableDataState<Product>, RootState>,
  axiosOptions?: AxiosRequestConfig,
): Promise<ApiResponse<Product[]>> {
  const currentProcessOrderIds = context.rootGetters['auth/currentProcessOrderIds'];

  const { data } = await fetchActiveCrops(currentProcessOrderIds, axiosOptions);

  return data;
}

async function fetchByIds(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ids: string[],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  context: ActionContext<SubscribableDataState<Product>, RootState>,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  axiosOptions?: AxiosRequestConfig,
): Promise<ApiResponse<Product[]>> {
  throw new Error('NOT IMPLEMENTED');
}

export const subscribableStore = subscribableData(fetchAll, fetchByIds);
